<template>
	<div class="tw-flex-col tw--mx-3">
		<div class="px-3 tw-pb-3">
			<c-title-header
				:title="selectedJob.name"
				@go-to-back="goTo(codeStep.returnTo)"></c-title-header>
		</div>
		<div class="tw-flex">
			<div class="px-3 tw-w-3/5">
				<model-stepper
					:current-step="5"
					class="tw-mb-4"
					@code-step="loadCodeStep">
				</model-stepper>
				<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between tw-my-">
					<div class="tw-flex tw-justify-between tw-items-center tw-mb-1">
						<p class="tw-text-app-color-primary text-lg">
							Agregar Experiencias Laborales
						</p>
						<p-button
							type="primary"
							:disabled="tableExperience.length >= codeStep.max"
							@click="addExperience"
						>Agregar Experiencia</p-button>
					</div>
					<div class="info tw-flex tw-item-center tw-gap-x-6 tw-mb-3">
						<img src="/static/img/enter.svg" alt="">
						<p>Presionar enter para agregar experiencia</p>
					</div>
					<section class="experience">
						<div class="text-upppercase experience-header tw-px-10 tw-py-1 tw-flex tw-justify-items-start tw-mb-4 tw-gap-x-32">
							<span>EXPERIENCIA</span>
							<span>DETALLE</span>
						</div>
						<div class="experience-list">
							<table>
								<tr v-for="(experienceT, index) in tableExperience" :key="index">
									<td class="exp tw-pr-1">
										<v-select
											class="select-core"
											hide-details
											:menu-props="{ contentClass: 'type-select-content' }"
											height="37"
											outline
											single-line
											autocomplete
											placeholder="Seleccionar Experiencia"
											:items="experience.data"
											item-value="id"
											item-text="name"
											v-model="selectedExperience[index]"
											return-object
											@input="getExperience($event, index)"
										></v-select>
									</td>
									<td class="detail tw-pl-1">
										<input
											placeholder="Detalle"
											v-model="details[index]"
											class="experience-input"
											@input="getDetail($event, index)"
											@keyup.enter="handleEnterKey">
									</td>
									<td>
										<app-tooltip-button
											img="/static/img/close2.svg"
											text="Eliminar"
											@click-icon="deleteExperience(index)"
										/>
									</td>
								</tr>
							</table>
						</div>
						<p-empty-message v-if="tableExperience.length === 0">
							Agregar la experiencia laboral<br>necesaria para el puesto
						</p-empty-message>
						<div>
							<p-horizontal-divider />
							<div class="tw-text-center">
								<p-button
									type="primary"
									@click="goTo(codeStep.returnTo)"
								>
									Atrás
								</p-button>
								<p-button
									type="secondary"
									:disabled="validateEmptyFields || tableExperience.length === 0"
									@click="saveStepExperience"
								>
									Siguiente
								</p-button>
							</div>
						</div>
					</section>
				</p-card>
			</div>
			<div class="px-3 tw-w-2/5">
				<model-description
					:title="'EXPERIENCIA LABORAL DEL PUESTO'"
					:subtitle="'INSTRUCCIONES'">
					<div class="tw-my-4" slot="content">
						<p style="font-size: 13px;" class="tw-text-center">Añade hasta 3 experiencias laborales dentro del puesto de trabajo, 
							teniendo en cuenta la necesidad del puesto.
						</p>
						<div class="content-box">
							<table>
								<tr>
									<th rowspan="4">Ejemplo:</th>
								</tr>
								<tr>
									<th class="titles">Tiempo de Experiencia</th>
									<th class="titles">Detalles de la experiencia</th>
								</tr>
								<tr>
									<td class="borders"></td>
									<td class="borders"></td>
								</tr>
								<tr>
									<td class="verbs">No Requiere</td>
									<td class="complements">Este puesto no requiere de una descripción</td>
								</tr>
							</table>
						</div>
						<div class="tw-flex tw-flex-col tw-items-center">
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
							>
								Mira nuestro tutorial paso a paso
							</p-button>
						</div>
					</div>
				</model-description>
			</div>
		</div>
	</div>
</template>

<script>
import cTitleHeader from '@/modules/job-profile/components/content/c-title-header';
import modelStepper from '@/modules/job-profile/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';

const { getLocalData } = helper;

async function loadData() {
	try {
		if (this.codeStep && this.selectedJob) {
			// ✅ USAR CACHE - Llamar al servicio centralizado con cache
			const response = await this.$store.dispatch('jobProfile/loadJobDescription', {
				codeStep: this.codeStep.code,
				jobId: this.selectedJob.id,
			});

			if (Object.keys(response).length !== 0) {
				this.tableExperience = response.description;
				this.selectedExperience = response.description.map(item => item.experience);
				this.details = response.description.map(item => item.detail);
				this.validateEmptyFields = this.tableExperience
					.some(item => !item.experience || !item.detail);
			} else {
				this.selectedExperience = this.experience.data
					.filter(el => el.id === this.selectedJob.experience);
				this.tableExperience = this.selectedExperience;
				this.tableExperience = this.tableExperience.map((f) => {
					const newF = {
						experience: f,
						detail: '',
					};
					return newF;
				});
			}
		}
	} catch (error) {
		this.showGenericError();
	}
}

function loadCodeStep(obj) {
	this.codeStep = obj;
}

function handleEnterKey() {
	if (this.tableExperience.length < this.codeStep.max) {
		this.tableExperience.push({
			experience: {},
			detail: '',
		});
	} else {
		this.showNotification('RECUERDA: Solo puedes agregar 3 experiencias', 'warning');
	}
	this.validateEmptyFields = this.tableExperience.some(item => !item.experience || !item.detail);
}

function addExperience() {
	this.tableExperience.push({
		experience: {},
		detail: '',
	});
	this.validateEmptyFields = this.tableExperience.some(item => !item.experience || !item.detail);
}

function getExperience(item, index) {
	this.selectedExperience[index] = item;
	this.tableExperience[index].experience = this.selectedExperience[index];
	this.validateEmptyFields = this.tableExperience.some(itemT => !itemT.experience || !itemT.detail);
}

function getDetail(detail, index) {
	this.details[index] = detail.target.value;
	this.tableExperience[index].detail = this.details[index];
	this.validateEmptyFields = this.tableExperience.some(itemT => !itemT.experience || !itemT.detail);
}

function deleteExperience(index) {
	this.tableExperience.splice(index, 1);
	this.selectedExperience.splice(index, 1);
	this.details.splice(index, 1);
	this.validateEmptyFields = this.tableExperience.some(item => !item.experience || !item.detail);
}

async function saveStepExperience() {
	this.tableExperience = this.tableExperience.map((f) => {
		const newF = { ...f };
		newF.experience = {
			id: f.experience.id,
			name: f.experience.name,
			code: f.experience.code,
		};
		return newF;
	});
	const body = {
		description: this.tableExperience,
		typeDescriptionCode: this.codeStep.code,
		jobId: this.selectedJob.id,
	};
	try {
		await this.$httpPraktiko.post('job-description', body);

		// ✅ INVALIDAR CACHE - Limpiar cache del job que se acaba de guardar
		this.$store.dispatch('jobProfile/clearJobDescriptionCache', this.selectedJob.id);

		this.showNotification('Experiencias Requeridas Guardado Exitosamente');
		this.goTo(this.codeStep.goTo);
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		codeStep: {},
		details: [],
		selectedExperience: [],
		tableExperience: [],
		validateEmptyFields: true,
	};
}

export default {
	name: 'job-required-work-experience',
	created() {
	},
	beforeMount() {
		// ✅ OPTIMIZADO: model-stepper ya carga la configuración
		// this.$store.dispatch('jobProfile/loadJobProfileConfig');
		this.$store.dispatch('jobEvaluation/loadExperiences');
	},
	mounted() {
	},
	data,
	components: {
		cTitleHeader,
		modelStepper,
		PCard,
		PEmptyMessage,
		PButton,
		PHorizontalDivider,
		modelDescription,
	},
	methods: {
		loadData,
		loadCodeStep,
		handleEnterKey,
		addExperience,
		getExperience,
		getDetail,
		deleteExperience,
		saveStepExperience,
	},
	computed: {
		...mapState('jobProfile', {
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
		}),
		...mapState('jobEvaluation', {
			experience:
				pathOr([], ['supplies', 'guidelineModel', 'levelSelection', 'experience']),
		}),
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},
	},
};

</script>

<style lang="scss" scoped>
.info {
	border: 1px solid color(border-gray) !important;
	background-color: color(gray-light) !important;
	border-radius: 50px;
	color: color(gray-sidebar);
	font-size: size(medium);
	height: 30px !important;
	padding: 2px 10px;
	width: 50%;
}
.experience {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
	&-list {
		display: flex;
		bottom: 0;
		left: 0;
		padding: 0;
		position: relative !important;
		right: 0;
		table {
			width: 100%;
			.exp {
				color: color(orange-light);
				font-size: size(large);
				padding-top: 4px;
				width: 25%;
			}
			.detail {
				width: 75%;
			}
		}
	}
	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
        display: block;
        outline: none;
		color: color(gray-tabs) !important;
		margin-top: 4px;
		padding: 10px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
.content-box {
	border: 1px solid color(border-gray);
	background-color: color(gray-light);
	border-radius: 5px;
	height: auto;
	width: 100%;
	padding: 10px;
	table {
		width: 100%;
		// border-collapse: collapse;
		text-align: center;
		font-size: 12px;
	}
	.borders {
		border-top: 1px solid color(green-dark);
		border-left: 1px solid color(green-dark);
		border-right: 1px solid color(green-dark);
		padding: 2px 0;
	}
	.titles {
		color: color(green-dark);
	}
	.verbs {
		color: color(orange-light);
	}
	.complements {
		color: color(gray-slider);
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/experience-page.vue/job-required-work-experience.vue